import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { certificateAPI, letterAPI } from '../api/documents';
import '../styles/AdminDashboard.css';

function AdminDashboard() {
  const [stats, setStats] = useState({
    certificates: 0,
    letters: 0,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadStats();
  }, []);

  const loadStats = async () => {
    try {
      const [certs, letters] = await Promise.all([
        certificateAPI.getAll(),
        letterAPI.getAll(),
      ]);
      setStats({
        certificates: certs.length,
        letters: letters.length,
      });
    } catch (error) {
      console.error('Failed to load stats:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-dashboard">
      <div className="dashboard-container">
        <h1 className="dashboard-title">Document Management System</h1>
        <p className="dashboard-subtitle">Manage certificates and letters</p>

        {loading ? (
          <div className="loading">Loading statistics...</div>
        ) : (
          <>
            <div className="stats-grid">
              <div className="stat-card">
                <div className="stat-icon">📜</div>
                <div className="stat-number">{stats.certificates}</div>
                <div className="stat-label">Certificates</div>
              </div>
              <div className="stat-card">
                <div className="stat-icon">✉️</div>
                <div className="stat-number">{stats.letters}</div>
                <div className="stat-label">Letters</div>
              </div>

            </div>

            <div className="actions-grid">
              <Link to="/dashboard/create-certificate" className="action-card">
                <div className="action-icon">🎓</div>
                <h3>Create Certificate</h3>
                <p>Generate internship certificates with QR verification</p>
              </Link>

              <Link to="/dashboard/create-letter" className="action-card">
                <div className="action-icon">📝</div>
                <h3>Create Letter</h3>
                <p>Generate official letters on Robolog letterhead</p>
              </Link>



              <Link to="/dashboard/manage-documents" className="action-card">
                <div className="action-icon">📊</div>
                <h3>Manage Documents</h3>
                <p>View and manage all generated documents</p>
              </Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default AdminDashboard;
